import { useRef } from "react";
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer";
import NotificationsView from "../../system/settings/views/NotificationsView";
import User from "../models/User";


interface IProps {
    user: User
    // The saved user comes back from the server, so the list row can be refreshed
    // without a reload.
    onSaved?: (user: User) => void
    onClose: () => void
}

// The very same settings page the user sees for themselves, opened on someone else.
export default function UserNotificationsDrawer(props: IProps) {

    const drawer = useRef<DrawerRef>(null)

    return (
        <Drawer ref={drawer} title="Notifications"
            titleIcon="bell-on"
            subtitle={props.user.fullName}
            size="large"
            onClose={props.onClose}>

            <NotificationsView target={props.user}
                onSaved={user => {
                    props.onSaved?.(user)
                    drawer.current?.close()
                }} />

        </Drawer>
    )
}
